module.exports = __webpack_public_path__ + "static/media/filledComment.0fa0a559.svg";